import { ticketHref, ticketSpans } from "./reason";

/**
 * A stored reason, with ticket keys rendered as links (S0.5 / DA-3339).
 *
 * The reason is free text an operator typed, so it is rendered as TEXT NODES
 * and never as markup — `ticketSpans` returns runs to render rather than a
 * string of HTML precisely so this component cannot be the place an injected
 * angle bracket matters.
 *
 * A key that does not resolve is a better failure than a reference shown as
 * plain text: the pattern cannot know which projects exist (see `reason.ts`),
 * and a dead link is visibly a dead link, while an unlinked key just looks
 * like nobody bothered.
 */
export function Reason({ text, className = "" }: { text: string; className?: string }) {
  return (
    <span className={className}>
      {ticketSpans(text).map((span, i) =>
        span.key ? (
          <a
            key={i}
            href={ticketHref(span.key)}
            target="_blank"
            // `noreferrer` as well as `noopener`: the target is an internal
            // Jira instance and the referrer would leak which console page
            // an operator was on when they followed it.
            rel="noopener noreferrer"
            className="underline"
          >
            {span.text}
          </a>
        ) : (
          <span key={i}>{span.text}</span>
        ),
      )}
    </span>
  );
}
